import { Search as SearchIcon } from 'blaze-ui/icons'
import Styles from '../TemplatesV2.module.scss'
import { Input } from 'almanac-ui/TextInputField/Input'
import { useState } from 'react'
import cx from 'classnames'

interface Props {
  placeholder?: string
  query?: string
  onChange: (newQuery: string) => void
  useCompactUI?: boolean
}

export const Search = ({ query, onChange, placeholder, useCompactUI = false }: Props) => {
  const autoFocus = !useCompactUI
  const [isFocused, setIsFocused] = useState(autoFocus)

  const placeholderText = placeholder ?? (useCompactUI ? 'Search all templates...' : 'Search thousands of templates...')

  return (
    <div className={cx(Styles.searchContainer, { [Styles.focused]: isFocused, [Styles.compact]: useCompactUI })}>
      <div className={Styles.searchIconContainer}>
        <SearchIcon color={isFocused ? 'var(--selected-stroke)' : 'var(--dark-80)'} />
      </div>
      <Input
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholderText}
        name="Search"
        value={query || ''}
        autoComplete="off"
        size="md"
        withBorder={false}
        className={Styles.searchInput}
        autoFocus={autoFocus}
        onBlur={() => setIsFocused(false)}
        onFocus={() => setIsFocused(true)}
      />
    </div>
  )
}
